import { PppCategory, PppType } from "@/types";

export const PPP_TYPES = ["product", "partner", "project"] as const satisfies readonly PppType[];

export const PPP_TYPE_LABEL: Record<PppType, string> = {
  product: "Product",
  partner: "Partner",
  project: "Project",
};

/** Meeting rule of thumb, shown as helper text in the form. */
export const PPP_TYPE_HINT: Record<PppType, string> = {
  product: "B2C — serves many customers (Infina App, OpTech platform)",
  partner: "B2B / B2B2C counterpart (ZaloPay, TPBank, Savills, KAFI)",
  project: "Internal initiative (brand, software factory, process automation)",
};

export const PPP_TYPE_BADGE: Record<PppType, string> = {
  product: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800",
  partner: "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-950 dark:text-sky-300 dark:border-sky-800",
  project: "bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-800",
};

export const PPP_TYPE_DOT: Record<PppType, string> = {
  product: "bg-emerald-500",
  partner: "bg-sky-500",
  project: "bg-orange-500",
};

/** Same lanes as Objective.category; "company" is cross-cutting work (accounting, legal, HR ops). */
export const PPP_CATEGORIES: PppCategory[] = ["fintech", "ai", "company"];

export const PPP_CATEGORY_LABEL: Record<PppCategory, string> = { fintech: "Fintech", ai: "AI", company: "Company" };

/** Grid shared by the /ppp header and rows: rank · name · category · KRs · DRI · deliverables · menu */
export const PPP_ROW_COLS = { gridTemplateColumns: "56px 1fr 90px 220px 160px 110px 40px" } as const;
